import * as React from "react";
import FormikAutocompleteField from "../../formik/FormikAutocomplete";
import PropTypes from "prop-types";
import { HttpClientConfig } from "../../../utils/HttpClient";

export const GenderAutocomplete = (props) => {
  const lookupUrl = `${HttpClientConfig.baseURL}/Gender/Lookup`;
  const lookupByIdUrl = `${HttpClientConfig.baseURL}/Gender/LookupById`;

  const handleAddClick = (e) => {
    console.log(e);
  }

  return (
    <FormikAutocompleteField {...props} lookupUrl={lookupUrl} lookupByIdUrl={lookupByIdUrl} onAddButtonClick={handleAddClick} />
  );
};

GenderAutocomplete.propTypes = {
  fieldName: PropTypes.string,
  label: PropTypes.string,
  formik: PropTypes.any
}

export default GenderAutocomplete;
